<div [formGroup]="tighteningFormGroup">
    <div class="modal-header w-100">
        <div class="row w-100">
            <div class="col-md-6">
                <div>
                    <h4>Joint Tightening Details</h4>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-body output-lable activity_body">
        <!-- <app-tightening-method [enable]="enable" [form]="tighteningFormGroup"></app-tightening-method> -->
        <div class="row">
            <div class="col-md-2">
                <mat-label class="font-style" placement="right" container="body" tooltipClass="custom-tooltip">
                    {{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_INPUT.METHOD' | transloco }}
                </mat-label>
            </div>
            <div class="col-md-10 method-select-btn">
                <div class="btn-group custom-toggle-wrap" role="group" [class.disable-div]="enable">
                    <label
                        *ngFor="let opt of stateOptions"
                        class="btn custom-toggle"
                        [class.active]="opt.value === tighteningFormGroup.get('tighteningMethod')?.value"
                    >
                        <input
                            type="radio"
                            class="btn-check"
                            [value]="opt.value"
                            [formControl]="tighteningFormGroup.get('tighteningMethod')"
                            autocomplete="off"
                        />
                        {{ opt.label }}
                    </label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-2">
                <mat-label class="font-style" placement="right" container="body" tooltipClass="custom-tooltip">
                    <!-- Bolt Type -->
                    Tool Selection
                </mat-label>
            </div>
            <div class="col-md-10">
                <ng-template #boltType_tooltip>
                    <p>
                        {{ 'TOOLTIP.INFORMATE_CALC_LABELS.BOLT_TYPE' | transloco }}
                    </p>
                </ng-template>
                <mat-select formControlName="ToolId" name="selectedTool" class="input-select" (selectionChange)="selectedToolChange($event)">
                    <mat-option *ngFor="let item of toolsData" [value]="item.id">{{ item.manufacturer.name }} - {{ item.name }}</mat-option>
                </mat-select>
            </div>
        </div>
        <br />
        <div class="row" *ngIf="tighteningMethod == 0">
            <div class="col-md-2">
                <!-- <mat-label class="font-style" placement="right" container="body" tooltipClass="custom-tooltip">
              
                    Torque Applied
                  </mat-label> -->
            </div>
            <div class="col-md-10">
                <div formGroupName="TorqueApplied">
                    <div class="table-title">
                        <h5 class="table-titleh4">Torque Applied</h5>
                    </div>
                    <div class="table">
                        <div class="table-row header">
                            <div class="table-cell">Unit</div>
                            <ng-container formArrayName="PassValues">
                                <div *ngFor="let passValue of torquePassValues1.controls; let i = index" [formGroupName]="i" class="table-cell">
                                    {{ ButtonValues(passValue) }}
                                </div>
                            </ng-container>
                        </div>
                        <div class="table-row">
                            <div class="table-cell">
                                <mat-select
                                    formControlName="Unit"
                                    (selectionChange)="torqueUnitChange($event)"
                                    name="selectedTool"
                                    class="input-select selectCustom"
                                >
                                    <mat-option *ngFor="let item of torqueUnitOptions" [value]="item.value">{{ item.value }}</mat-option>
                                </mat-select>
                            </div>
                            <ng-container formArrayName="PassValues">
                                <div *ngFor="let passValue of torquePassValues1.controls; let i = index" [formGroupName]="i" class="table-cell">
                                    <input type="text" class="control txtCustom" formControlName="Value" [class.disable-div]="ToolingValue" />
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <!-- <div class="sticky-controls">
                        <mat-select  formControlName="Unit" (selectionChange)="torqueUnitChange($event)"   name="selectedTool" class="input-select selectCustom">
                            <mat-option  *ngFor="let item of torqueUnitOptions" [value]="item.value">{{ item.value}}</mat-option>
                          </mat-select>
                                     
                      </div>
                      <div class="sticky-controls" formArrayName="PassValues">
                        <div   *ngFor="let passValue of torquePassValues1.controls; let i = index" [formGroupName]="i">
           
                            <button type="button" [class.btnCustom1]="ButtonValues(passValue) == 'Check Pass'" [class.btnCustom]="ButtonValues(passValue) != 'Check Pass'" disabled="disabled" class="btn primary-ebtn">{{ButtonValues(passValue)}}</button>
                            <input type="text"  class="control txtCustom" formControlName="Value" [class.disable-div]="ToolingValue">                    
                        </div> 
                      </div> -->
                </div>
            </div>
        </div>
        <div class="row" *ngIf="(tighteningMethod == 0 && selectedTool.isPowered == true) || tighteningMethod == 1">
            <div class="col-md-2">
                <!-- <mat-label class="font-style" placement="right" container="body" tooltipClass="custom-tooltip">
                    Pressure Applied
                  </mat-label> -->
            </div>
            <div class="col-md-10">
                <div formGroupName="PressureApplied">
                    <div class="table-title">
                        <h5 class="table-titleh4">Pressure Applied</h5>
                    </div>
                    <div class="table">
                        <div class="table-row header">
                            <div class="table-cell">Unit</div>
                            <ng-container formArrayName="PassValues">
                                <div *ngFor="let passValue of pressurePassValues1.controls; let i = index" [formGroupName]="i" class="table-cell">
                                    {{ ButtonValues(passValue) }}
                                </div>
                            </ng-container>
                        </div>
                        <div class="table-row">
                            <div class="table-cell">
                                <mat-select
                                    formControlName="Unit"
                                    (selectionChange)="tensionUnitChange($event)"
                                    name="selectedTool"
                                    class="input-select selectCustom"
                                >
                                    <mat-option *ngFor="let item of TensionUnitOptions" [value]="item.value">{{ item.value }}</mat-option>
                                </mat-select>
                            </div>
                            <ng-container formArrayName="PassValues">
                                <div *ngFor="let passValue of pressurePassValues1.controls; let i = index" [formGroupName]="i" class="table-cell">
                                    <input type="text" class="control txtCustom" formControlName="Value" [class.disable-div]="ToolingValue" />
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <!-- <div class="sticky-controls">
                        <mat-select  formControlName="Unit"  (selectionChange)="tensionUnitChange($event)" name="selectedTool" class="input-select selectCustom">
                            <mat-option  *ngFor="let item of TensionUnitOptions" [value]="item.value">{{ item.value}}</mat-option>
                          </mat-select>
                               
                      </div>
                      <div class="sticky-controls" formArrayName="PassValues">
                        <div  *ngFor="let passValue of pressurePassValues1.controls; let i = index" [formGroupName]="i">
                            <button type="button" disabled="disabled" class="btn primary-ebtn btnCustom">{{ButtonValues(passValue)}}</button>
                            <input type="text" class="control txtCustom" formControlName="Value" [class.disable-div]="ToolingValue">                      
                        </div> 
                      </div> -->
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-2">
                <mat-label class="font-style" placement="right" container="body" tooltipClass="custom-tooltip">
                    <!-- Bolt Type -->
                    Tooling Value As
                </mat-label>
            </div>
            <div class="col-md-10">
                <mat-checkbox class="chkToolingValue" color="primary" (change)="toolValueChecked($event)" formControlName="ToolingValueAs"></mat-checkbox
                ><br /><br />
            </div>
        </div>
        <div class="row">
            <div class="col-md-2">
                <mat-label class="font-style" placement="right" container="body" tooltipClass="custom-tooltip">
                    <!-- Bolt Type -->
                    Bolt Stress
                </mat-label>
            </div>
            <div class="col-md-10">
                <mat-label class="font-style" placement="right" container="body" tooltipClass="custom-tooltip">
                    <!-- Bolt Type -->
                    {{ resBoltStress }}
                </mat-label>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn primary-ebtn" (click)="Submit()">Save</button>
        <button type="button" class="btn secondary-ebtn" (click)="closeClick()">{{ 'PLANT_MANAGER.Cancel' | transloco }}</button>
    </div>
</div>
